var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconEstateFeature5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 71 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M57.954 45.728 5.383 28.273M5.383 21.728l52.57-17.455M1 21.729c0-1.2.986-2.182 2.19-2.182 1.205 0 2.19.982 2.19 2.182v6.545c0 1.2-.985 2.182-2.19 2.182A2.193 2.193 0 0 1 1 28.274V21.73Z",
  stroke: "#999",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M64.525 32.637v13.09A3.275 3.275 0 0 1 61.239 49a3.275 3.275 0 0 1-3.286-3.272V32.637M57.953 17.364V4.273A3.275 3.275 0 0 1 61.24 1a3.275 3.275 0 0 1 3.286 3.273v13.09M28.38 35.908v5.454l-15.333-5.454v-5.455M38.234 10.818v28.364",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.102 22.819c2.628 0 1.752-2.182 4.38-2.182 2.629 0 1.753 2.181 4.381 2.181 2.629 0 1.753-2.181 4.381-2.181 2.629 0 1.753 2.181 4.381 2.181 2.629 0 1.753-2.181 4.381-2.181M43.719 27.184c2.628 0 1.752 2.181 4.38 2.181 2.63 0 1.753-2.181 4.382-2.181 2.628 0 1.752 2.181 4.38 2.181 2.63 0 1.753-2.181 4.381-2.181 2.629 0 1.753 2.181 4.381 2.181",
  stroke: "#B18D3B",
  strokeLinejoin: "round"
})));

export default SvgIconEstateFeature5;